import { atlas } from '~/services/serviceInstances';

export const deleteGuideline = async ({
  guidelineId,
}: {
  guidelineId: string;
}) => {
  return atlas.remove(`guidelines/${guidelineId}`);
};
